import { useContext } from 'react';
import { AnalyticsContext } from 'components/Contexts';
import { AnalyticsContextReturn } from 'components/Contexts/AnalyticsContext';

const useAnalytics = (): AnalyticsContextReturn => useContext(AnalyticsContext);

export default useAnalytics;
